export default "__VITE_ASSET__C9DfB8$6__"